import axios from "../helper/axios";
import { create } from "zustand";

const useJDStore = create((set,get) => ({
    jdData: [],
    myJdData: [],
    jdsPriorityPagination: [],
    jdsPriorityPaginationInternal: [],
    selectedJD: null,
    selectedJDMapData: null,
    jdCreationError: null,
    isJDCreated: false,
    refreshJDFlag: false,
    jdUpdatedFlag: false,
    panelList: [],  
    allJDsCount:0,
    myJDsCount:0,
    jdsPriorityCountPagination:0,
    jdsPriorityCountInternal:0,
    selectedEvent:null,
    jdEventsData:[],
    allJDsEventCount:0,
    jdEventsStats:[],

    getAllJds: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const statusvalue = "All"; // workaround... get rid of the status dependency
            const response = await axios.get(
                `/getAllJds?account_type=${userData.account_type}&owner_id=${userData.qhoid}&status=${statusvalue.status} `
            );
            set({ jdData: response.data.data });
            set({ allJDsCount: response.data.totalcount });
            
            console.log(response.data.name);
            //console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    },
    getAllJdsPagination: async (filterDuration, data) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(`/getAllJdsPagination/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${filterDuration}`,data);
             
            set({ jdData: response.data.data });
            set({ allJDsCount: response.data.totalCount });
            
            console.log(response.data.name);
            console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }, 
    getAllJDsEventPagination: async (filterDuration, data) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(`/getAllJdsEventPagination/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${filterDuration}`,data);
             
            set({ jdEventsData: response.data.data });
            set({ allJDsEventCount: response.data.totalCount });
            set({ jdEventsStats: response.data.stats });
            
            console.log(response.data.name);
            console.log(response.data.data);
            console.log(response.data.stats);
        } catch (error) {
            console.log(error);
        }
    },    
    getMyJdsPagination: async (filterDuration, data) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(`/getMyJdsPagination/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${filterDuration}`,data);
             
            set({ myJdData: response.data.data });
            set({ myJDsCount: response.data.totalCount });
            
            console.log(response.data.name);
            console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    },       
    getJdsPriorityPagination: async (filterDuration, data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getJdsPriorityPagination/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${filterDuration}`,data);
           console.log(response.data.name); 
           console.log(response.data);
           set({ jdsPriorityPagination: response?.data.data });
           set({ jdsPriorityCountPagination: response?.data.totalCount });
           
           //console.log(response.data.data);
        } catch (err) {
            console.error(err);
        }
    }, 
    getJdsPriorityPaginationInternal: async (filterDuration, data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getJdsPriorityPaginationInternal/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${filterDuration}`,data);
           console.log(response.data.name); 
           console.log(response.data);
           set({ jdsPriorityPaginationInternal: response?.data.data });
           set({ jdsPriorityCountPaginationInternal: response?.data.totalCount });
           
           //console.log(response.data.data);
        } catch (err) {
            console.error(err);
        }
    },        
    updateResumesVersion: async (jdId) => {
        console.log("Updating resumes version for JD:", jdId);
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        try {
            const response = await axios.post(
                `/updateResumesVersion/${userData.qhoid}/${userData.qhuid}/${jdId}`
            );
            console.log(response.data);
            set({ selectedJD: response.data.selectedJD });
        } catch (err) {
            console.error(err);
        }
    },   
    getJdByID: async (id) => {
        try {
            //console.log("Called getJdByID",id);
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `getjdbyid/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/jds/${id}`
            );
            set({ selectedJD: response.data.data });
            set({ selectedJDMapData: response.data.mapdata });
            set({ refreshJDFlag: true });
            
            //console.log("getJdByID response",response.data.name,id);
            //console.log("JD Data--selectedJD",response.data.data);
            //console.log("Map Data",response.data.mapdata);
        } catch (error) {
            console.log(error);
        }
    },
    getJdEventByID: async (id,cb) => {
        try {
            //console.log("Called getJdEventByID",id);
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `getjdeventbyid/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/jds/${id}`
            );
            set({ selectedEvent: response.data.data });
            //console.log("JD Data--selectedEvent",response.data.data);
            // console.log("getJdEventByID response",response.data.name,id);

            if(cb) cb(response.data.data)

            //console.log("JD Data--selectedJD",response.data.data);
            //console.log("Map Data",response.data.mapdata);
        } catch (error) {
            console.log(error);
        }
    },    
    createJd: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));

            const response = await axios.post(
                `createjd/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`,
                body
            );
            //console.log(response.data.data);
            //console.log(response.data.name,response.data.data.QhCompanyJID);
            set({ isJDCreated: true });
            set({ selectedJD: response.data.data });
                
            return response.data.data.QhCompanyJID;
        } catch (error) {
            set({ jdCreationError: error });
        }
    },
    updateJd: async (body, jdId) => {
        try {
            //console.log("Updating JD", body)
            
            const userData = JSON.parse(localStorage.getItem("userDetails"));

            const response = await axios.put(
                `updatejd/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/jds/${jdId}`,                
                body
            );
            //console.log("Updated JD Successfully in backend",response.data);
            set({ jdUpdatedFlag: true });
        } catch (error) {
            set({ jdCreationError: error });
            //console.log("What error",error);
        }
    },
    updateJdEvent: async (body, jdId) => {
        try {
            console.log("Updating JDEvent", body)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.put(
                `updatejdevent/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/jds/${jdId}`,                
                body
            );
            console.log("Updated JD Successfully in backend",response.data);
        } catch (error) {
            set({ jdCreationError: error });
            //console.log("What error",error);
        }
    },    
  duplicateJd: async (jdId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.get(
        `duplicatejd/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${jdId}`,
      );
    } catch (error) {
      set({ jdDuplicationError: error });
    }
  },

  deleteJd: async (jdId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.delete(
        `deletejd/${userData.account_type}/${userData.qhoid}/${jdId}`,
      );
    } catch (error) {
      set({ jdDeleteError: error });
    }
  },
    updateJdStatus: async (status, jdId) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.put(
                `updatejdstatus/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/jds/${jdId}/${status}`
            );
        } catch (error) {
            set({ jdCreationError: error });
            //console.log("What error",error);
        }
    },
    postAssignment: async (id, value) => {
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        try {
            const response = await axios.put(`/assign/TeamMember/${userData.qhoid}/${userData.qhuid}/jds/${id}`, value);
            if (response.status === 200) {
                return true
            }else{
                return false
            }
        } catch (error) {
            console.log(error);
        }
    },

    clearJD: () => {
        //console.log("clearJD");
        set({ selectedJD: null });
        set({ selectedJDMapData: null });
    },
    resetJDRefreshFlag: () => {
        set({ refreshJDFlag: false });
    },
    resetJDUpdatedFlag: () => {
        set({ jdUpdatedFlag: false });
    },    

    getSelectedJD: () => {
         return get().selectedJD;   // <- use Zustand's get()
    },   

    createPanel: async (jdId,body) => {
        try {
            console.log("create panel called", jdId, body);

            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/createPanel/${userData.qhoid}/${userData.qhuid}/${jdId}`,
                body
            );
            console.log("create panel response", response.data);
            
            return response.data;
        } catch (error) {
            console.log(error);
            set({ jdCreationError: error });
        }
    },
    getJDPanel: async (jdId) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getJDPanel/${userData.qhoid}/${userData.qhuid}/${jdId}`
            );
            console.log("get panel response", response.data.panel_list);
            set({ panelList: response.data.panel_list });
            return response.data;
        } catch (error) {
            console.log(error);
            set({ jdCreationError: error });
        }
    },

    
}));

export default useJDStore;
